// extracted by mini-css-extract-plugin
module.exports = {"ripple":"_3cRG38pNXY302aP-uw-iIX","rippleWrapper":"_2AWhQ6mkBwjnOta75XQSFv","rippleRestarting":"y45XADMV3QScYjXJkvNxS","rippleActive":"_1QiQfZHkjJBnbSuhZq66jr"};